import React, { useEffect } from 'react'
import FashionGroupBanner from '../../../../../../../public/assets/img/bannerBg.svg'
import MobileFashionGroupBanner from '../../../../../../../public/assets/img/mobileTradendingBg.png'
import { MEN_SECTION_TEXT } from 'src/Helpers/Json/ManCategoryList'
import { useAppDispatch } from 'src/store/store'
import { fetchApplianceCategory } from 'src/store/slices/manageApplianceCategorySlice'
import { useRouter } from 'next/router'
import ClubSlider from 'src/components/StoreAndProductDetailModal/ClubModal/ClubSlider'
import { useAuth } from 'src/utils/auth'
import { guestAccountDetailSlice } from 'src/store/slices/guestAccountDetailSlice'
import { useSelector } from 'react-redux'
import { fetchManageClubsData } from 'src/store/slices/fetchAllClubsSlice'

export default function FashionGroups(props) {
  const router = useRouter()
  const { user }: any = useAuth()
  const dispatch = useAppDispatch()
  const allManageClub = useSelector((state: any) => state?.clubData?.manageClubs)

  const leaveClubYouManageCall = (club) => {
    if (user) {
    } else {
      handleRedirect()
    }
  }

  useEffect(() => {
    dispatch(fetchManageClubsData({ page: 1, limit: 100, type: 'SUGGESTED_CLUBS' }))
  }, [])

  const joingroupCall = (club) => {
    if (user) {
    } else {
      handleRedirect()
    }
  }

  const handleRedirect = () => {
    dispatch(
      guestAccountDetailSlice({
        modal: 'authModal',
        isOpen: true,
        id: {
          media: 'https://storage.googleapis.com/bluejestic-media/bluejestic-stage/loginmedia/Live-Shopping-Short.mp4',
          modalFor: 'login',
          startWith: 'loginModal',
        },
      }),
    )
  }

  return (
    <div className="fashionGroups-section">
      <div className="fashionGroups-back-alignment">
        <div
          className="back_details-alignment"
          onClick={() => {
            router.push('/fashion/women/', undefined, { scroll: false })
            dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
          }}
        >
          <div>
            <img src="/assets/icon/left-icon.svg" alt="back-page" />
          </div>
          <p>Woma...</p>
        </div>
        <div className="mobile-heading-alignment">
          <h4>Now Trending</h4>
        </div>
      </div>
      <div className="fashionGroups-banner">
        <div className="fashionGroups-banner-img-alignment">
          <img src={FashionGroupBanner.src} alt="FashionGroupBanner" />
          <img src={MobileFashionGroupBanner.src} alt="MobileFashionGroupBanner" className="mobile-view-banner" />
        </div>
        <div className="container">
          <div className="fashionGroups-banner-section">
            <div
              className="left-arrow-alignment"
              onClick={() => {
                router.push('/fashion/women/', undefined, { scroll: false })
                dispatch(fetchApplianceCategory({ modal: '', isOpen: false, id: 0 }))
              }}
            >
              <img src="/assets/icon/leftArrow.svg" alt="left-arrow" />
            </div>
            <div className="fashionGroups-heading-alignment">
              <h4>Fashion Clubs</h4>
              <p>{MEN_SECTION_TEXT.fashion_group.text}</p>
            </div>
          </div>
        </div>
      </div>
      <div className="fashionGroups-details-alignment">
        <div className="container">
          <div className="fashion_group_details_grid">
            {allManageClub?.map((club, index) => {
              return (
                <React.Fragment key={index}>
                  <ClubSlider
                    club={club}
                    leaveGroupCall={leaveClubYouManageCall}
                    joingroupCall={joingroupCall}
                    isOpen={true}
                  />
                </React.Fragment>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
